import { Link } from 'react-router-dom';
import { featuredMovies } from '@/mocks/movies';
import { siteConfig } from '@/mocks/site';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20ambiance%2C%20warm%20red%20and%20black%20velvet%20tones%2C%20dramatic%20spotlight%20beam%20effect%2C%20luxurious%20vintage%20cinema%20hall%20atmosphere%2C%20artistic%20abstract%20geometric%20pattern%20with%20soft%20gradients%2C%20elegant%20film%20noir%20aesthetic&width=1920&height=800&seq=hero-bg-main&orientation=landscape"
          alt="小辣椒影院"
          className="w-full h-full object-cover object-top"
        />
      </div>
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-background-50"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-wide animate-fade-in-up">
          {siteConfig.name}
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          {siteConfig.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <Link
            to="/category/dianying"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap inline-flex items-center gap-2"
          >
            <i className="ri-play-circle-fill w-5 h-5 flex items-center justify-center"></i>
            开始观影
          </Link>
          <Link
            to="/category/dianshiju"
            className="px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/25 font-medium text-sm hover:bg-white/25 transition-all duration-300 whitespace-nowrap"
          >
            热门剧集
          </Link>
        </div>

        {/* Quick Stats */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-12 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
          {[
            { icon: 'ri-movie-2-line', label: '影视作品', value: '100,000+' },
            { icon: 'ri-user-smile-line', label: '日活用户', value: '500万+' },
            { icon: 'ri-play-circle-line', label: '累计播放', value: '50亿+' },
            { icon: 'ri-thumb-up-line', label: '好评率', value: '98.5%' },
          ].map((stat) => (
            <div key={stat.label} className="flex items-center gap-2 text-white/90">
              <i className={`${stat.icon} w-5 h-5 flex items-center justify-center text-primary-400`}></i>
              <div className="text-left">
                <div className="text-lg md:text-xl font-bold">{stat.value}</div>
                <div className="text-xs text-white/60">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl w-6 h-6 flex items-center justify-center"></i>
      </div>
    </section>
  );
}